import Mounter from 'shared/utils/mounter';
import documentReady from 'document-ready';
import AuthorizationForm from './authorization/authorization_form';
import PublicClientAuthorizeForm from './authorization/public_client_authorize_form';
import PublicClientConsentForm from './authorization/public_client_consent_form';

documentReady(() => {
  new Mounter({
    AuthorizationForm,
    PublicClientAuthorizeForm,
    PublicClientConsentForm,
  }).mountAll();
});
